import React from 'react';
import { observer } from 'mobx-react';
import { Table, TableBox } from 'libs/connection';
import { useAppManager } from 'apps/hooks';
import { Button } from 'components';
import { PortalLink } from 'apps/client/components/PortalLink';
import { SortByAction, FilterByAction } from 'libs/connection/actions';
import { ShipmentQuotesConnectionManager } from '../connManager';

interface OpenQuoteButtonProps {
  node: {
    id: string;
  };
}

const actions = {
  leftActions: [SortByAction, FilterByAction],
  // rightActions: [],
};

const OpenQuoteButton = ({ node }: OpenQuoteButtonProps) => (
  <PortalLink name='quote' params={{ quoteId: node.id }}>
    <Button
      size='small'
      text='Open'
      outline
      icon='arrow_right'
      iconPosition='right'
    />
  </PortalLink>
);

export const QuoteList = observer(() => {
  const conn = useAppManager(ShipmentQuotesConnectionManager, null);

  return (
    <TableBox
      wrapperStyle={{
        py: null,
        mx: null,
      }}
    >
      <Table
        {...{
          contentName: 'Quotes',
          subRowsAccessor: 'productQuotes',
          columns: conn.finalColumns,
          actions,
          conn,
          RowActionButtons: OpenQuoteButton,
        }}
      />
    </TableBox>
  );
});
